import { Box, CircularProgress, Typography } from '@material-ui/core'

import BulkCommissionTable, { StoreCommissionValue } from '../BulkCommissionTable'
import { BulkGoalClasses } from '../../types'

interface CommissionStepProps {
  classes: BulkGoalClasses
  commissionAutofillStatus: 'idle' | 'loading' | 'fetched' | 'applied' | 'skipped'
  values: StoreCommissionValue[]
  onApplyToAll: (
    field: keyof Omit<StoreCommissionValue, 'storeId' | 'storeName'>,
    value: boolean | 'single' | 'multiple' | null
  ) => void
  onChange: (
    storeId: string,
    field: keyof Omit<StoreCommissionValue, 'storeId' | 'storeName'>,
    value: boolean | 'single' | 'multiple' | null
  ) => void
}

const CommissionStep = ({
  classes,
  commissionAutofillStatus,
  values,
  onApplyToAll,
  onChange
}: CommissionStepProps) => (
  <div className={classes.stepContainer}>
    {commissionAutofillStatus === 'loading' && (
      <Box mb={2} display='flex' alignItems='center' justifyContent='center'>
        <CircularProgress size={16} style={{ marginRight: 8 }} />
        <Typography color='textSecondary' variant='body2'>
          Analisando configurações anteriores...
        </Typography>
      </Box>
    )}
    <h1 className={classes.title}>Configuração de comissão por loja</h1>
    <Typography className={classes.subtitle}>
      Revise as regras copiadas da última meta ativa de cada loja.
    </Typography>
    <BulkCommissionTable
      values={values}
      onChange={onChange}
      onApplyToAll={onApplyToAll}
    />
  </div>
)

export default CommissionStep
